import React, { useEffect, useState } from "react";
import { agentRepo } from "@/repo/agent-repo";
import { AgentData, MovieAgent } from "@/entry/server/agents";
import { ASSETS_BASE_URL } from "@/utils/constants";
import NoPersonIcon from "@public/img/no-person.png";

export default function MovieAgents({ id }: { id: number }) {
    const [agents, setAgents] = useState<MovieAgent | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(function () {
        agentRepo.getMovieAgents(id).then(function (response) {
            if (response.status) {
                setAgents(response.data);
            }
            setLoading(false);
        });
    }, [id]);

    if (loading) {
        return (
            <div className="movie-detail-agents">
                <div className="movie-detail-agents__shimmer" />
                <div className="movie-detail-agents__shimmer" />
            </div>
        );
    }

    if (!agents) {
        return null;
    }

    return (
        <div className="movie-detail-agents">
            {agents.directors.length > 0 && (
                <AgentsBox title="کارگردان" data={agents.directors} isLeft={true} />
            )}
            {agents.actors.length > 0 && (
                <AgentsBox title="بازیگران" data={agents.actors} isLeft={false} />
            )}
        </div>
    );
}

function AgentsBox(props: { title: string; data: AgentData[]; isLeft: boolean }) {
    var boxClass = "movie-detail-agents__box";
    if (props.isLeft) {
        boxClass += " movie-detail-agents__box--left";
    }

    return (
        <div className={boxClass}>
            <p className="movie-detail-agents__title">{props.title}</p>
            <div className="movie-detail-agents__list">
                {props.data.map(function (item) {
                    return <AgentCard key={item.id + "-" + props.title} data={item} />;
                })}
            </div>
        </div>
    );
}

function AgentCard({ data }: { data: AgentData }) {
    var posterSrc = data.image_url.indexOf("http") === 0
        ? data.image_url
        : ASSETS_BASE_URL + data.image_url;

    return (
        <div className="movie-detail-agents__card">
            {data.image_url.length > 0 ? (
                <img src={posterSrc} alt={data.name} />
            ) : (
                <img src={NoPersonIcon} alt={data.name} />
            )}
            <p className="movie-detail-agents__card-name">{data.name}</p>
            {data.role && data.role !== "" && (
                <p className="movie-detail-agents__card-role">{data.role}</p>
            )}
        </div>
    );
}
